import cn from "classnames";

import { Typography } from "shared/ui/components/Typography";

import { DetailedTable } from "../DetailedTable";

import styles from "./FinancingCard.module.scss";
import { convertValueToLocale } from "helpers/convertValueToLocale";

const renderValueByKey = (value: any, key: string) => {
  switch (key) {
    case "quantity":
      return convertValueToLocale(value);
    default:
      return value;
  }
};

const _cellRenderer = ({
  className,
  item,
  key,
  justifyContent,
  cellType,
  minWidth,
  maxWidth,
}) => {
  switch (key) {
    default: {
      const value =
        cellType !== "boolean" ? item[key] || "" : item[key] || false;

      return (
        <div
          className={cn(styles.cell, className)}
          key={key}
          style={{
            minWidth,
            maxWidth,
            justifyContent: justifyContent,
            padding: "8px 12px",
          }}
        >
          <Typography className={cn(styles.text)} variant="numbers">
            {renderValueByKey(value, key)}
          </Typography>
        </div>
      );
    }
  }
};

const FinancingCard = ({ items, columns }: any) => {
  return (
    <DetailedTable
      title="Finanzierungsbedarf"
      data={items}
      columns={columns}
      cellRenderer={(props) => _cellRenderer(props)}
    />
  );
};

export default FinancingCard;
